<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          :route="baseUrl"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi"
          id="nuidentif" >
          <template slot-scope="propSlot">
            <span>{{`${propSlot.item.nomeescola} - ${propSlot.item.descricaoetapaescolar} `}}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :disabled="acao != ''" :options="buscaOptions" v-model="buscarSelect" @change="$refs.buscaSimpleApi.busca = ''"/>
      </v-flex>
    </v-layout>
    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <FormBasico
      :acao="acao"
      :id="form.nuidentif"
      :novo="novo"
      :editar="editar"
      :excluir="excluir"
      :cancelar="cancelaretapaescolar"
      :submit="onSubmit"
      >

      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabela">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <SelectBuscaApi
                  style="width: 60%;"
                  id="identificadorescola"
                  route="gerencial/escola"
                  fieldSearch="nomeescola"
                  label="Nome da Escola"
                  v-if="!visualizar"
                  :disabled="acao == '' || acao == 'editar'"
                  :v="$v.form.identificadorescola"
                  v-model="form.identificadorescola">
                  <template slot-scope="propSlot">
                    {{textoBuscaApi(propSlot.item)}}
                  </template>
            </SelectBuscaApi>
          <Input type="text" v-if="visualizar" label="Nome da Escola" v-model="form.nomeescola" disabled />



          <Select :options="modalidadeOptions" v-model="form.identificadormodalidadeetapa" label="Modalidade" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadormodalidadeetapa"/>
          <Select :options="nivelOptions" v-model="form.identificadorniveletapa" label="Nível Organização" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadorniveletapa"/>
          <Select :options="faseOptions" v-model="form.identificadorfaseetapa" label="Fase" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadorfaseetapa"/>
          <Select :options="etapaOptions" v-model="form.identificadoretapaescolar" label="Etapa Escolar*" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadoretapaescolar"/>
          <Validator label="A Etapa Escolar da escola está sendo utilizada?" :disabled="acao == ''" :v="$v.form.indicausoetapaescola">
            <Radio v-model="form.indicausoetapaescola" :disabled="acao == ''" val="N" label="Não"/>
            <Radio v-model="form.indicausoetapaescola" :disabled="acao == ''"  val="S" label="Sim"/>
          </Validator>
          <!-- <pre>Ação: {{ acao }}</pre>
          <pre>{{ form | pretty }}</pre> -->
        </v-card-text>
      </v-card>
    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
  import api from '@/api'
  import BuscaSimplesApi from '@/components/BuscaSimplesApi'
  import SelectBuscaApi from '@/components/SelectBuscaApi'
  import { required, maxLength, minLength, alpha, integer } from 'vuelidate/lib/validators'
  import { alphaSpace } from '@/validations'

  let setFormInicial = () => {
    return {
      identificadoretapaescolar: '',
      identificadormodalidadeetapa: '',
      identificadorniveletapa: '',
      identificadorfaseetapa: '',
      indicausoetapaescola: 'S',
      identificadorescola: '',
    }
  }

  export default {
    name: 'EtapaEscolar',
    components: {
      BuscaSimplesApi,
      SelectBuscaApi
    },
    data () {
      return {
        baseUrl : 'gerencial/etapaescolarescola',
        acao: '',
        form: setFormInicial(),
        submitText: '',
        snackbar: false,
        msgArrayError: [],
        buscarSelect: 'nomeescola',
        // buscaValidaSelect : false,
        // areas: [],
        buscaOptions: [
          { value: 'nomeescola', text: 'Escola' },
          { value: 'descricaoetapaescolar', text: 'Etapa Escolar' },
          { value: 'identificadorescola', text: 'Código da Escola' },
          { value: 'identificadoretapaescolar', text: 'Código da Etapa Escolar' }
        ],
        visualizar: false,
        modalidadeOptions: [],
        nivelOptions: [],
        faseOptions: [],
        etapaOptions: [],
        formUltimo: {}
      }
    },
    validations: {
      form: {
        // descricaoetapaescolar: { required, alphaSpace, maxLength: maxLength(100), minLength: minLength(4) },
        // siglaetapaescolar: { required, alphaSpace, maxLength: maxLength(2), minLength: minLength(2) },
        identificadormodalidadeetapa: {required},
        identificadorniveletapa: {required},
        identificadorfaseetapa: {required},
        identificadorescola: {required},
        identificadoretapaescolar: {required},
      }
    },
    created: function() {
      //this.carregaModalidade();
    },
    watch:{
      'form.identificadormodalidadeetapa'(newVal){
        if(this.acao){
          this.nivelOptions = []
          this.faseOptions = []
          this.etapaOptions = []
          this.form.identificadorniveletapa = ''
          this.form.identificadorfaseetapa = ''
          this.form.identificadoretapaescolar = ''
          if(newVal != 0)
            this.carregaNivel()
        }
      },
      'form.identificadorniveletapa'(newVal) {
        if(this.acao){
          this.faseOptions = []
          this.etapaOptions = []
          this.form.identificadorfaseetapa = ''
          this.form.identificadoretapaescolar = ''
          if(newVal != 0)
            this.carregaFase()
        }
      },
      'form.identificadorfaseetapa'(newVal) {
        if(this.acao){
          // this.faseOptions = []
          this.etapaOptions = []
          // this.form.identificadorfaseetapa = ''
          this.form.identificadoretapaescolar = ''
          if(newVal != 0)
             this.carregaEtapaEscolar()
        }
      }

    },
    methods: {
      getTipoDependenciaAdministrativa(tipo) {
          switch (tipo) {
            case '1': return 'Federal';
            case '2': return 'Estadual';
            case '3': return 'Municipal';
            case '4': return 'Privada';
            default: return '';
          }
      },
      textoBuscaApi(dados) {
        let nomeCidade = '';
        let tipoDependenciaAdministrativa = '';

        if (dados.tipodependenciaadministrativa) { tipoDependenciaAdministrativa = `, ${this.getTipoDependenciaAdministrativa(dados.tipodependenciaadministrativa)}`; }

        if (dados.logradouro.nomecidade || dados.nomecidadeinternacionalescola) { nomeCidade = ` - ${((dados.logradouro) ? dados.logradouro.nomecidade : dados.nomecidadeinternacionalescola).toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())}`; }

        return `${dados.nomeescola}${tipoDependenciaAdministrativa}${nomeCidade}`;
      },
      tabela(){
        this.$root.$router.push({
            name: 'tabelas',
            params: {
              titulo: 'Etapa Escolar da Escola / Listar',
              rota_api: 'gerencial/etapaescolarescola/tabela',
              ordemGrid: true,
              headers: [
                { text: 'Identificador Escola', value: 'identificadorescola',sortable: true},
                { text: 'Escola', value: 'nomeescola', sortable: true},
                { text: 'Identificador Etapa Escolar', value: 'identificadoretapaescolar', sortable: true},
                { text: 'Etapa Escolar', value: 'descricaoetapaescolar', sortable: true},
                { text: 'Etapa Escolar em uso?', value: 'indicausoetapaescola', sortable: true},
                // { text: 'Fase', value: 'descricaofaseetapa', sortable: false}
              ]
            }
        });
      },
      encontrado (dados) {
        this.visualizar = true;
        this.form = setFormInicial()
        this.form = { ...dados }
        this.formUltimo = { ...dados }
        this.limpaSelect();
        this.$refs.buscaSimpleApi.lista = [];

        this.modalidadeOptions.push({value: this.form.identificadormodalidadeetapa , text: this.form.descricaomodalidadeetapa })
        this.nivelOptions.push({value: this.form.identificadorniveletapa , text: this.form.descricaoniveletapa })
        this.faseOptions.push({value: this.form.identificadorfaseetapa , text: this.form.descricaofaseetapa })
        this.etapaOptions.push({value: this.form.identificadoretapaescolar , text: this.form.descricaoetapaescolar})
      },
      novo(){
        this.acao = 'novo'
        this.visualizar = false;

        this.form = setFormInicial()
        this.$v.$reset();
        this.limpaSelect();
        this.carregaModalidade();
      },
      editar(){
        this.acao = 'editar'
      },
      excluir: async function () {
        const confirmar = await this.$sgal({
          title: 'Tem certeza?',
          text: "Deseja realmente excluir esta etapa escolar desta escola?",
          type: 'warning',
          buttons: [
            { text: 'Excluir', color: 'red', response: true },
            { text: 'Cancelar', color: 'grey', response: false }
          ]
        })

        if(confirmar){
          try{
            const { data } = await api.delete(`${this.baseUrl}/${this.form.identificadorescola}/${this.form.identificadoretapaescolar}`)

            this.acao = '';
            this.submitText = data.message;
            this.snackbar = true;
            this.form = setFormInicial()
            this.msgArrayError = []
            this.$v.$reset();
            this.limpaSelect();
          }
          catch (error) {
            const ntfExcluir = await this.$sgal({
              title: 'Não foi possível!',
              text: error.response.data.errorMessage[0],
              type: 'notification'
            })
          }
        }
       },
      cancelaretapaescolar(){
        if(this.acao == 'novo') {
          this.form = setFormInicial()
          this.limpaSelect()
        }
        else {
          this.form = { ...this.formUltimo }
        }
        this.acao = ''
        this.msgArrayError = []

        this.$v.$reset();
      },
      async carregaModalidade(){
        const { data } = await api.get('gerencial/modalidadeetapa')
        this.modalidadeOptions.push({value:'', text: '' })
        for (const key of data.results) {
          this.modalidadeOptions.push({value: key.identificadormodalidadeetapa , text: key.descricaomodalidadeetapa })
        }
        if(!this.acao)
        await this.carregaNivel()
        //console.log(this.modalidadeOptions )
      },
      async carregaNivel(){
        const { data } = await api.get('gerencial/nivelorganizacaoetapa?identificadormodalidadeetapa='+this.form.identificadormodalidadeetapa)
        this.nivelOptions.push({value:'', text: '' })
        for (const key of data.results) {
          this.nivelOptions.push({value: key.identificadorniveletapa , text: key.descricaoniveletapa })
        }
        if(!this.acao)
        await this.carregaFase()
        //console.log(this.modalidadeOptions )
      },
      async carregaFase(){
        const { data } = await api.get('gerencial/faseetapa?identificadormodalidadeetapa='+this.form.identificadormodalidadeetapa+'&identificadorniveletapa='+this.form.identificadorniveletapa)
        this.faseOptions.push({value:'', text: '' })
        for (const key of data.results) {
          // console.log('key:', key.identificadorfaseetapa);
          this.faseOptions.push({value: key.identificadorfaseetapa , text: key.descricaofaseetapa })
        }
        if(!this.acao)
        await this.carregaEtapaEscolar()
        //console.log(this.modalidadeOptions )
      },
      async carregaEtapaEscolar(){
        const { data } = await api.post('gerencial/etapaescolar/getEtapaEscolarFiltros', {
          identificadormodalidadeetapa: this.form.identificadormodalidadeetapa,
          identificadorniveletapa: this.form.identificadorniveletapa,
          identificadorfaseetapa: this.form.identificadorfaseetapa,
        })

        this.etapaOptions.push({value:'', text: '' })
        for (const key of data.results) {
          this.etapaOptions.push({value: key.identificadoretapaescolar , text: key.descricaoetapaescolar})
        }
        // console.log('to aqui' )
      },
      onSubmit(){
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        api({
          method: (this.acao === 'novo') ? 'post' : 'put',
          // url: 'gerencial/etapaescolarescola' + ((this.acao === 'novo') ? '' : `/${this.form.identificadoretapaescolar}`),
           url: this.baseUrl,
          data: this.form
        }).then((response) => {
          this.acao = '';
          this.submitText = response.data.message;
          this.snackbar = true;
          this.msgArrayError = []
            this.form = {
                       ...response.data.results
                        }
            // this.form = {
            //            ...response.data.results,
            //            identificadormodalidadeetapa: this.form.identificadormodalidadeetapa,
            //            identificadorniveletapa: this.form.identificadorniveletapa,
            //            identificadorfaseetapa: this.form.identificadorfaseetapa
            //             }
        }).catch((error) => {
          if(error.response.data.status == 'ERROR_BUSINESS_RULE')
            this.msgArrayError = error.response.data.errorMessage
          if(window.scrollY >= 250)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })
        // this.$v.$reset()
      },
      limpaSelect(){
        this.modalidadeOptions = []
        this.nivelOptions = []
        this.faseOptions = []
        this.etapaOptions = []
      }
    },

  }
</script>

<style >

</style>
